// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2M4jz","content":"ManualTimeModal_content__NgIN-"};